<template>
  <div class="mian-cls">
    <!-- 客服链接 -->
    <router-link to="/chat" target="_blank" class="customer-link-cs">
      <img src="@/assets/englishhome/customer.png" alt="">
    </router-link>

    <!-- 首屏区域 -->
    <div class="flex-box first-box">
      <img src="@/assets/englishhome/logo.png" alt="" class="logo-cls">
      <div class="first-left">
        <img class="logo-title-cls" src="@/assets/englishhome/QSIM_title.png" alt="">
        <div>QSIM is an application designed to provide users<br>
          with a secure and efficient communication<br>
          environment. It supports multi-device login,<br>
          independent deployment, encrypted message/file<br>
          transmission, and powerful group features.</div>
      </div>
      <img :class="['first-right', width >= 1400 ? 'full-cls' : 'small-cls']"
        :src="require(`@/assets/englishhome/fisrt_bg${width >= 1400 ? '_full' : ''}.png`)" alt="">
    </div>

    <!-- 安全特性区域 -->
    <div class="second-cls">
      <div class="flex-box">
        <div class="left-box"><img src="@/assets/englishhome/second_phone.png" class="phone-img" alt=""></div>
        <div class="right-box">
          <h2>Enhanced Security</h2>
          <template v-for="(item, index) in securityList">
            <div :key="index" class="flex-box item-cls">
              <img class="icon-cls" :src="item.icon" alt="">
              <span>{{item.title}}</span>
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- 群组特性区域 -->
    <div class="three-cls">
      <div class="flex-box">
        <div class="left-box">
          <h2>Advanced Group Features</h2>
          <p class="tag-cls">Supports large groups of up to 5,000 members</p>
          <template v-for="(item, index) in featuresList">
            <div :key="index" class="flex-box item-cls">
              <div style="flex: 1"></div>
              <img class="icon-cls" :src="item.icon" alt="">
              <span>{{item.title}}</span>
            </div>
          </template>
        </div>
        <div class="right-box"><img src="@/assets/englishhome/htree_phone.png" class="phone-img" alt=""></div>
      </div>
    </div>

    <!-- 多设备登录区域 -->
    <div class="four-cls">
      <div class="text-box">
        <div class="left-text">
          <h2>Multi-Device Login</h2>
          <div>QSIM supports iOS, Android, Windows, macOS, and Web,<br>
            meeting diverse usage scenarios. The PC version also <br>
            features multi-window mode, enabling users to manage<br>
            groups more efficiently and enhance collaboration <br>
            productivity.</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.width = window.innerWidth;
    }
  },
  data() {
    return {
      width: window.innerWidth,
      securityList: [
        {
          icon: require("@/assets/englishhome/second_icon_1.png"),
          title: 'End-to-End Encryption'
        },
        {
          icon: require("@/assets/englishhome/second_icon_2.png"),
          title: 'Encrypted Message Transmission'
        },
        {
          icon: require("@/assets/englishhome/second_icon_3.png"),
          title: 'Encrypted File Transfer'
        },
        {
          icon: require("@/assets/englishhome/second_icon_4.png"),
          title: 'App Lock Feature'
        }
      ],
      featuresList: [
        {
          icon: require("@/assets/englishhome/three_icon_1.png"),
          title: 'One-click group cloning'
        },
        {
          icon: require("@/assets/englishhome/three_icon_2.png"),
          title: 'Restrict member friend requests'
        },
        {
          icon: require("@/assets/englishhome/three_icon_3.png"),
          title: 'Scheduled message cleanup'
        },
        {
          icon: require("@/assets/englishhome/three_icon_4.png"),
          title: 'Screenshot detection alerts'
        },
        {
          icon: require("@/assets/englishhome/three_icon_5.png"),
          title: 'Forced message recall'
        }
      ]
    }
  },
}
</script>

<style scoped lang="scss">
$main-width: 1400px;
$font-color: #6A6A6A;
$padding-right: 100px;

.mian-cls {
  margin: 0 auto;
  min-width: $main-width;

  .customer-link-cs {
    position: fixed;
    right: 20px;
    top: 40%;
    z-index: 99;
    width: 250px;
    transition: all 0.3s ease;
    transform-origin: center;
    filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1));
    cursor: pointer;

    img {
      width: 100%;
      transition: transform 0.3s ease;
    }

    &:hover {
      transform: translateY(-5px) scale(1.05);
      filter: drop-shadow(0 8px 15px rgba(0, 0, 0, 0.15));
    }

    &:active {
      transform: translateY(0) scale(0.98);
    }
  }

  .logo-cls { width: 258px; }

  .first-box {
    width: $main-width;
    margin: 0 auto;
    position: relative;
    padding-bottom: 80px;

    .logo-cls {
      position: absolute;
      left: 0;
      top: 10px;
    }

    .logo-title-cls { width: 460px; margin-bottom: 22px; }

    .first-left {
      flex: 1;
      font-size: 20px;
      color: $font-color;
      line-height: 32px;
      padding-left: 110px;
    }
  }

  .phone-img { width: 256px; }

  h2 { font-size: 36px; margin-bottom: 40px; }

  .item-cls {
    margin: 20px 0;
    font-size: 18px;
    font-weight: bold;
    .icon-cls { width: 32px; height: 32px; margin-right: 20px; }
  }

  .second-cls,
  .three-cls {
    padding: 80px 0;

    .left-box {
      flex: 1;
      text-align: right;
      padding-right: $padding-right;
    }

    .right-box { flex: 1; }
  }

  .second-cls {
    background-image: url("../../assets/englishhome/second_bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .three-cls {
    .left-box {
      padding-right: 120px;
    }
    h2 { margin-bottom: 20px; }
    .tag-cls {
      color: $font-color;
      font-size: 20px;
      margin-bottom: 30px;
      padding-right: 36px;
    }

    .item-cls{
      //justify-content: right;
      >span {
        width: 396px;
        text-align: left;
      }
    }
  }

  .four-cls {
    padding: 60px 0;
    background-color: #E2F8EE;

    .text-box {
      background-image: url("../../assets/englishhome/four_right.png");
      background-repeat: no-repeat;
      background-size: auto 100%;
      background-position: center right;
      width: $main-width;
      margin: 0 auto;
      color: $font-color;
      font-size: 20px;
      line-height: 36px;
      padding: 120px 0;

      h2 { color: #000; }
      .left-text { text-align: center; width: 50%; }
    }
  }
}

.flex-box {
  display: flex;
  align-items: center;
}

.first-right {
  width: 733px;
}

@media screen and (min-width: 1400px) {
  .first-right { width: 950px; padding-left: 100px }
}
</style>
